export default "__VITE_ASSET__DDafL3Hp__"